import React, { useEffect } from "react";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { FullScreenExteriorModalType } from "../../../../utils/modalConstants";
import { useAphBreakpoint } from "../../../../../shared-logic/hooks/useBreakpoint";
import Exterior360 from "../spin/exterior-360/Exterior360";
import Upholstery from "../spin/Upholstery";
import Modal from "../../../../../shared-components/css-modules/lexus/organisms/Modal";
import styles from "./FullScreenSpinModal.module.scss";
import SpinNavigation from "../spin/SpinNavigation";
import { useCarConfigSelector } from "../../../../redux/store";
import { SpinnerType } from "../../../../redux/slices/CarConfigSpinNavigationSlice";

const FullScreenSpinModal = (props: ModalViewType<FullScreenExteriorModalType>): JSX.Element => {
    const { show, close } = props;
    const upholsterySpinIsActive = useCarConfigSelector(
        (state) => state.carConfigSpinNavigation.activeSpin === SpinnerType.Upholstery,
    );
    const isMobile = useAphBreakpoint("down", "md");

    useEffect(() => {
        if (isMobile) close();
    }, [close, isMobile]);

    return (
        <Modal open={show} onRequestClose={close} variant="fullscreen-spin">
            {!upholsterySpinIsActive && (
                <figure className={styles["image-wrapper"]}>
                    <Exterior360
                        index={3}
                        imageOptions={{
                            bgColour: "FFFFFF",
                            width: 2000,
                            height: 1106,
                            padding: 0,
                            srcSet: [
                                { width: 1624, height: 924 },
                                { width: 1850, height: 1053 },
                                { width: 2048, height: 1165 },
                            ],
                        }}
                    />
                </figure>
            )}
            {upholsterySpinIsActive && (
                <div className={styles["image-interior-wrapper"]}>
                    <Upholstery />
                </div>
            )}

            <SpinNavigation inModal showFullscreen />
        </Modal>
    );
};

export default FullScreenSpinModal;
